import { createContext, useContext, useEffect, useState } from "react";
import { EN } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("mc_lang") || "it");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("mc_lang", l);
    setLangState(l);
  };

  const t = (s) => (lang === "en" ? EN[s] ?? s : s);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
